import { render, staticRenderFns } from "./LoyaltyMoments.vue?vue&type=template&id=03a5850b&"
import script from "./LoyaltyMoments.vue?vue&type=script&lang=js&"
export * from "./LoyaltyMoments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports